import React from 'react';
import {StyleSheet, TouchableOpacity, View} from 'react-native';
import {Badge} from 'react-native-paper';
import Text from '../../../components/Text';
import {colorSwatches} from '../../../styles';

export default function DeliveryHeaderTabs({
  activeTab,
  deliveriesCount,
  setActiveTab,
  showDeliveries = true,
  unclaimedPackagesCount,
}: {
  activeTab: string;
  deliveriesCount: number;
  setActiveTab: (tab: string) => void;
  showDeliveries?: boolean;
  unclaimedPackagesCount: number;
}) {
  const tabs = showDeliveries ? ['Deliveries', 'Packages'] : ['Packages'];
  const tabLabels: Record<string, string> = {
    Packages: 'Packages',
    Deliveries: 'Deliveries',
  };

  return (
    <View style={styles.container}>
      <View style={styles.tabsRow}>
        {tabs.map(tab => {
          const count =
            tab === 'Packages' ? unclaimedPackagesCount : deliveriesCount;
          const isActive = activeTab === tab;

          return (
            <TouchableOpacity
              key={tab}
              style={[
                styles.tabWrapper,
                tabs.length === 1 && styles.singleTabWrapper,
                isActive && styles.activeTabWrapper,
              ]}
              onPress={() => setActiveTab(tab)}>
              <View style={styles.tabContent}>
                <Text style={styles.tabTitle}>{tabLabels[tab]}</Text>
                {!!count && <Badge style={styles.badge}>{`${count} `}</Badge>}
              </View>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: colorSwatches.primary.color,
  },
  tabsRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  tabWrapper: {
    paddingVertical: 6,
    flexDirection: 'row',
    borderBottomColor: colorSwatches.white.color,
    borderBottomWidth: 0,
    marginHorizontal: 4,
    paddingHorizontal: 6,
    width: '45%',
    opacity: 1,
  },
  singleTabWrapper: {
    width: '90%',
  },
  activeTabWrapper: {
    borderBottomWidth: 4,
  },
  tabContent: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  tabTitle: {
    color: colorSwatches.white.color,
    fontSize: 14,
    fontWeight: '600',
  },
  badge: {
    backgroundColor: 'red',
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '500',
    marginLeft: 8,
  },
});
